import { useQueries } from '@tanstack/react-query';

import {
  ContractSummary,
  fetchGetContract,
  fetchGetContractAccrualPeriods,
} from '@octopus/api';

export const useGetEmployeeInfo = (selectedContract: ContractSummary) => {
  const [contract, contractAccrualPeriods] = useQueries({
    queries: [
      {
        queryKey: ['contract', selectedContract?.contractId],
        queryFn: () =>
          fetchGetContract({
            pathParams: {
              contractId: selectedContract?.contractId,
              organizationId: selectedContract?.organizationId,
            },
          }),
        enabled: !!selectedContract?.contractId,
      },
      {
        queryKey: ['contract-accrual-periods', selectedContract?.contractId],
        queryFn: () =>
          fetchGetContractAccrualPeriods({
            pathParams: {
              contractId: selectedContract?.contractId,
              organizationId: selectedContract?.organizationId,
            },
          }),
        enabled: !!selectedContract?.contractId,
      },
    ],
  });
  const isLoading = contract.isLoading || contractAccrualPeriods.isLoading;

  return {
    contract,
    contractAccrualPeriods,
    isLoading,
  };
};
